import { render, staticRenderFns } from "./HistoryTwelve.vue?vue&type=template&id=5463df8b&scoped=true"
import script from "./HistoryTwelve.vue?vue&type=script&lang=js"
export * from "./HistoryTwelve.vue?vue&type=script&lang=js"
import style0 from "./HistoryTwelve.vue?vue&type=style&index=0&id=5463df8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5463df8b",
  null
  
)

export default component.exports